var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8307 19.1694C23.329 17.6683 21.2927 16.8251 19.1694 16.8251C17.0461 16.8251 15.0098 17.6683 13.5081 19.1694L7.84489 24.8307C6.34317 26.3324 5.49951 28.3692 5.49951 30.493C5.49951 32.6167 6.34317 34.6535 7.84489 36.1552C9.34661 37.6569 11.3834 38.5006 13.5071 38.5006C15.6309 38.5006 17.6677 37.6569 19.1694 36.1552L22.0001 33.3246",
    stroke: "white",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1692 24.8307C20.6709 26.3317 22.7072 27.175 24.8305 27.175C26.9538 27.175 28.9902 26.3317 30.4919 24.8307L36.155 19.1693C37.6567 17.6676 38.5004 15.6308 38.5004 13.5071C38.5004 11.3833 37.6567 9.34655 36.155 7.84483C34.6533 6.34311 32.6165 5.49945 30.4928 5.49945C28.369 5.49945 26.3322 6.34311 24.8305 7.84483L21.9999 10.6755",
    stroke: "white",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkLogoWhite);
export default __webpack_public_path__ + "static/media/linkLogoWhite.91278ffa1180505f3185dcd316cc42d9.svg";
export { ForwardRef as ReactComponent };